import { createUseQuery } from 'api/common/createUseQuery'
import { Carousel, fetchCarousel } from 'api/fetchers/carousels/fetchCarousel'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useCarousel = createUseQuery({
  queryKey: ApiQueryKeys.CAROUSEL,
  fetcher: fetchCarousel,
  selector: res => res?.data as Carousel[] | undefined,
})
